import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/interfaces/stores/RootState';
import Filter from '@/interfaces/api/Filter';
import { Page } from '@/interfaces/api/Page';
import { AxiosResponse } from 'axios';
import { Pagination } from '@/interfaces/api/Pagination';
import { StatisticOverviewItem } from '@/interfaces/models/StatisticOverviewItem';
import SyncApiService from '@/api/http/SyncApiService';
import { SyncJob } from '@/interfaces/models/SyncJob';

const api: SyncApiService = new SyncApiService();

interface SyncState {
  items: SyncJob[];
  filter: Filter;
  pagination: {
    total: number;
  };
  overview: StatisticOverviewItem[];
}

const state: SyncState = {
  pagination: {
    total: 0,
  },
  filter: {},
  items: [],
  overview: [],
};

const actions: ActionTree<SyncState, RootState> = {
  fetch({ commit, state }, page?: Page) {
    return api.index(page, { ...state.filter }).then((res: AxiosResponse<SyncJob[] | Pagination<SyncJob>>) => {
      commit('setItems', res.data);
    });
  },
  setFilter({ commit }, filter: Filter) {
    Object.keys(filter).forEach((key) => {
      if (!filter[key]) {
        delete filter[key];
      }
    });
    commit('setFilter', filter);
  },
  getItemEntries({ commit, state }, id: string) {
    return api.getItem(id).then((res: AxiosResponse<Partial<SyncJob>>) => {
      commit('setSyncItemEntries', res.data);
    });
  },
  setItem({ commit, state }, data: SyncJob) {
    commit('updateStatusItem', data);
  },
  stopSync({ commit, state }, id: string) {
    return api.stopSync(id);
  },
};

const mutations: MutationTree<SyncState> = {
  setItems(state: SyncState, data: Pagination<any>) {
    state.items = (data.data as SyncJob[]) || data;
    state.pagination.total = data?.total || 0;
  },
  setFilter(state: SyncState, data: Filter) {
    state.filter = data;
  },
  setSyncItemEntries(state: SyncState, data: SyncJob) {
    const syncItem: SyncJob | undefined = (state.items || []).find((i: SyncJob) => i.id === data.id);

    if (!syncItem) {
      return;
    }

    syncItem.entries = data.entries;
  },
};

export default {
  namespaced: true,
  mutations,
  state,
  actions,
};
